import clsx from 'clsx';
import React from 'react';
import styles from './WorkbenchQueryViewShimmer.module.scss';

export interface WorkbenchQueryViewShimmerProps {
  className?: string;
  showingInsideCard?: boolean;
}

export function WorkbenchQueryViewShimmer({
  className = '',
  showingInsideCard
}: WorkbenchQueryViewShimmerProps) {
  return (
    <div className={clsx('box', showingInsideCard ? 'box--inside-card border-left-0 border-right-0' : '', className)}>
      <div className='box__header'>
        <div
          className='shimmer shimmer-line'
          style={{ width: '67px', height: '12px' }}
        />
      </div>

      <div className='box__body'>
        <div className={styles.editorWrapper}>
          <div className={styles.gutter} />

          <div className={styles.code}>
            <div className='shimmer shimmer-line' style={{ width: '64px', height: '8px' }} />
            <div className='shimmer shimmer-line mt-3' style={{ width: '124px', height: '8px' }} />
            <div className='shimmer shimmer-line mt-3' style={{ width: '64px', height: '8px' }} />
            <div className='shimmer shimmer-line mt-3' style={{ width: '124px', height: '8px' }} />
          </div>
        </div>
      </div>
    </div>
  );
}
